import React from 'react';

const MapButton = ({ businessID = 0 }) => {
  // const businessID = 52;
  return (
    <a
      href={`/itpi/lighthouse/outlets/${businessID}`}
      style={{
        padding: '10px 20px',
        backgroundColor: 'rgb(247,247,247)',
        color: 'black'
      }}
    >
      <p style={{ fontFamily: 'EffraRegular' }}>View on map</p>
    </a>
  );
};
export default MapButton;
